// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3juPC","importantInfo":"styles_importantInfo__11RFB"};